import { supabase } from '../lib/supabaseClient';

export interface FormSubmissionData {
  formName: string;
  [key: string]: any;
}

export const submitFormToSupabase = async (submissionData: FormSubmissionData) => {
  const { formName, ...formData } = submissionData;

  const { data, error } = await supabase
    .from('form_submissions')
    .insert([
      { 
        form_name: formName, 
        data: formData 
      },
    ]);

  if (error) {
    console.error('Supabase form submission error:', error);
    return { success: false, error };
  }

  return { success: true, data };
};